import moment from "moment";
import { AdditionalConfig } from "./ConfigObject";
import { IsoToDateWithoutTime } from "../../../CommonFunction/IsoDateTime";

export const handleKeyDown = (evt, type) => {
  const isCtrlPressed = evt.ctrlKey || evt.metaKey;
  if (
    (type === "number" &&
      evt.key !== "Backspace" &&
      evt.key !== "ArrowLeft" &&
      evt.key !== "ArrowRight" &&
      evt.key !== "Delete" &&
      evt.key !== "." &&
      isNaN(evt.key) &&
      evt.key !== "Tab" &&
      !isCtrlPressed) ||
    evt.key === "ArrowUp" ||
    evt.key === "ArrowDown"
  ) {
    evt.preventDefault();
  }
};

export const capitalizeFirstCharacter = (event) => {
  const inputField = event.target;
  if (inputField.value.length > 0) {
    inputField.value = inputField.value
      .split(" ")
      .map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  }
  return inputField || {};
};

export const parseFinancialYearRange = (yearRange) => {
  if (!yearRange) return {};
  const [startDateStr, endDateStr] = yearRange.split(" - ");
  const [startDay, startMonth, startYear] = startDateStr.split("/").map(Number);
  const [endDay, endMonth, endYear] = endDateStr.split("/").map(Number);
  const startDate = new Date(startYear, startMonth - 1, startDay);
  const endDate = new Date(endYear, endMonth - 1, endDay);
  return { startDate, endDate };
};

export const disableDates = (currentDate, InputConfig) => {
  if (!InputConfig?.restrictDateRange) {
    // If InputConfig.restrictDateRange is false, do not disable any dates
    return false;
  }
  // For disabling past dates
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  // Check if we need to disable past dates (for "Loading_Date")
  if (InputConfig?.name === "Loading_Date" && currentDate.valueOf() < today.valueOf()) {
    return true;
  }
  // Retrieve the financial year range from sessionStorage
  const selectedFinancialYearString = sessionStorage.getItem("SelectedFinancialYear");
  let yearRange = null;
  if (selectedFinancialYearString) {
    const selectedFinancialYear = JSON.parse(selectedFinancialYearString);
    yearRange = selectedFinancialYear.yearRange;
  }
  // If there's no financial year range, return based on the "Loading_Date" condition
  if (!yearRange) {
    // Optionally log an error or handle cases where the financial year is not set
    return InputConfig?.name === "Loading_Date";
  }
  // For disabling dates outside the financial year range
  const { startDate, endDate } = parseFinancialYearRange(yearRange);
  // Ensure the currentDate is not before startDate and not after endDate
  const isOutsideFinancialYear = currentDate < startDate || currentDate > endDate;
  return isOutsideFinancialYear;
};

export const OpenMasterModal = (
  e,
  event,
  setIsModalOpen,
  setcompName,
  isModalOpen,
  setProps,
  dispatch,
  MasterData,
  FormKey,
  PushModal,
  id
) => {
  let config = AdditionalConfig;
  let data = config[e?.masterName];
  console.log(config, "configconfigconfig");
  if (!data?.addMaster) {
    return;
  }
  let obj = {
    show: isModalOpen,
    ParentPortalCloseFunction: () => {
      const byName = document.getElementsByName(e.name);
      const byId = id ? document.getElementById(id) : null;
      // console.log('focus id:', id, 'element found:', byId);

      // focus the element if found
      console.log(byId);
      if (byId) {
        byId.focus();
      } else if (byName.length > 0) {
        byName[0].focus();
      }
      setIsModalOpen(false);
      dispatch({ type: "CLEAR_COMPONENT_PROP" });
    },
  };

  if (event.keyCode === 113) {
    console.log(data.Form_Key);
    // dispatch({ type: "Refetch", payload: 0 });
    // 113 is the keycode for F2
    event?.preventDefault && event.preventDefault(); // Prevent the default F2 action
    setIsModalOpen(true);
    const cmp = () => data.addMaster;
    setcompName(cmp);
    console.log(data, "eeeeeeee");
    setProps({
      ...obj,
      show: true,
      TypeOfPortal: "Add",
      ...(data?.Form_Key === "Account_Vouchers" && {
        AddComp: ["Vendor_Account", "Customer_Account", "General_Account", "Bank_Cash_Account", "Employee_Account"],
      }),
      submitType: "Save",
      ReferenceFieldName: e?.Reference_field
        ? [
            {
              FieldName: e,
            },
          ]
        : [e],
      ReferFormKey: FormKey,
    });
    dispatch({
      type: "SET_COMPONENT_PROP",
      payload: {
        Table_Key: data?.Form_Key,
        props: {
          ...obj,
          show: true,
          TypeOfPortal: "Add",
          ...(data?.Form_Key === "Account_Vouchers" && {
            AddComp: ["Vendor_Account", "Customer_Account", "General_Account", "Bank_Cash_Account", "Employee_Account"],
          }),
          ReferenceFieldName: e?.Reference_field
            ? [
                {
                  FieldName: e,
                },
              ]
            : [e],
          ReferFormKey: FormKey,
        },
      },
    });
    PushModal(data?.Form_Key);
  }

  if (event.keyCode === 117) {
    let row_Data = MasterData;
    console.log(e, "eeeeeeee", row_Data);
    if (row_Data) {
      dispatch({
        type: "UNIQUE_TABLE_LIST",

        payload: {
          key: data?.Form_Key,
          data: {
            Selected_Rows: [row_Data],
            Selected_Row: row_Data,
            SelRow_id: [row_Data?._id],
            SelRow_ids: [row_Data?._id],
          },
        },
      });
      event?.preventDefault && event.preventDefault(); // Prevent the default F2 action
      setIsModalOpen(true);
      const cmp = () => data.addMaster;
      setcompName(cmp);
      // console.log(e);
      setProps({
        ...obj,
        show: true,
        TypeOfPortal: "Edit",
        ...(data?.Form_Key === "Account_Vouchers" && { AccountID: MasterData?._id }),
        ReferenceFieldName: e?.Reference_field
          ? [
              {
                FieldName: e,
              },
            ]
          : [e],
        ReferFormKey: FormKey,
      });
      dispatch({
        type: "SET_COMPONENT_PROP",
        payload: {
          Table_Key: data?.Form_Key,
          props: {
            ...obj,
            show: true,
            TypeOfPortal: "Edit",
            ...(data?.Form_Key === "Account_Vouchers" && { AccountID: MasterData?._id }),
            ReferenceFieldName: e?.Reference_field
              ? [
                  {
                    FieldName: e,
                  },
                ]
              : [e],
            ReferFormKey: FormKey,
          },
        },
      });
      PushModal(data?.Form_Key);
    }
  }
};

export const CheckDisable = (current, InputConfig, SelectedDate, dates, Section_Type, FormData) => {
  if (InputConfig?.restrictDateRange) {
    if (InputConfig?.Reference_field) {
      if (InputConfig?.headerDate) {
        let fromDate = SelectedDate?.FromDate ? IsoToDateWithoutTime(SelectedDate?.FromDate) : dates && dates[0];
        let toDate = SelectedDate?.ToDate ? IsoToDateWithoutTime(SelectedDate?.ToDate) : dates && dates[1];

        let startDate = dates && dates[0];
        let endDate = dates && dates[1];

        if (InputConfig?.name === "From") {
          return (
            current &&
            (current < moment(startDate, "DD/MM/YYYY").startOf("day") ||
              current > moment(toDate, "DD/MM/YYYY").endOf("day"))
          );
        } else if (InputConfig?.name === "To") {
          return (
            current &&
            (current < moment(fromDate, "DD/MM/YYYY").startOf("day") ||
              current > moment(endDate, "DD/MM/YYYY").endOf("day"))
          );
        }
      }
      if (InputConfig?.Reference_field === "financialYear") {
        let startDate = dates && dates[0];
        let endDate = dates && dates[1];
        return (
          current &&
          (current < moment(startDate, "DD/MM/YYYY").startOf("day") ||
            current > moment(endDate, "DD/MM/YYYY").endOf("day"))
        );
      } else {
        let specificDate = FormData?.[Section_Type]?.[InputConfig?.Reference_field];
        return current && current < moment(specificDate, "DD/MM/YYYY").startOf("day");
      }
    }
    return current && current < moment().startOf("day");
  }
  return disableDates(current.toDate());
};

// Helper function to construct className string
export const getClassName = (type, className, Touch_inp) => {
  const baseClass = `form__field ${className} no-spinners`;
  if (["InputDropForQuery", "inputdrop", "GoogleSearch", "apiButtonInput"].includes(type)) {
    return `${Touch_inp} ${baseClass} dropdownInput`;
  }
  return baseClass;
};
